import $ from "jquery";

const myAccountMenu = () => {
  const init = () => {
    action();
  };

  const el = {
    cartIcon: ".my-account-menu--cartWrapper",
    cartItem: ".cart-item",
  }

const action = () => {
    // CART ICON
    $(document).on("mouseenter",el.cartIcon, function () {
        $(el.cartItem).addClass("active");
    })

    $(document).on("mouseleave",el.cartIcon, function () {
        $(el.cartItem).removeClass("active");
    })

    // CART ITEM
    $(document).on("mouseenter",el.cartItem, function () {
        $(this).addClass("active");
    })
    $(document).on("mouseleave",el.cartItem, function () {
        $(this).removeClass("active");
    })
};

  init();
};

try {
  myAccountMenu();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
